import { render, staticRenderFns } from "./TableRowAudiologistToPhysicianRatio.vue?vue&type=template&id=7322459c&lang=pug&"
import script from "./TableRowAudiologistToPhysicianRatio.vue?vue&type=script&lang=js&"
export * from "./TableRowAudiologistToPhysicianRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7322459c')) {
      api.createRecord('7322459c', component.options)
    } else {
      api.reload('7322459c', component.options)
    }
    module.hot.accept("./TableRowAudiologistToPhysicianRatio.vue?vue&type=template&id=7322459c&lang=pug&", function () {
      api.rerender('7322459c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/benchmarks/table-rows/TableRowAudiologistToPhysicianRatio.vue"
export default component.exports